import { usePayorCredentialEditors } from './usePayorCredentialEditors';
import { usePayorCredentialsList } from './usePayorCredentialsList';

export function useProviderPayorCredentialsSection() {
  const {
    payorCredentials,
    setPayorCredentials,
    sortedPayorCredentials,
    credsLoading,
    credentialSearchStr,
    payorCredentialsSortField,
    payorCredentialsSortOrder,
    isNewCredentialAdding,
    setIsNewCredentialAdding,
    editableCredentialIndex,
    setEditableCredentialIndex,
    handleCredentialSearch,
    sortPayorCredentials,
  } = usePayorCredentialsList();

  const {
    handleAddCredential,
    handleEditCredential,
    handleCancelEditCredential,
    handleUpdateCredential,
    handleDeleteCredential,
  } = usePayorCredentialEditors({
    payorCredentials,
    setPayorCredentials,
    setEditableCredentialIndex,
    setIsNewCredentialAdding,
  });

  return {
    payorCredentials,
    sortedPayorCredentials,
    credsLoading,
    credentialSearchStr,
    payorCredentialsSortField,
    payorCredentialsSortOrder,
    isNewCredentialAdding,
    editableCredentialIndex,
    handleAddCredential,
    handleCredentialSearch,
    sortPayorCredentials,
    handleEditCredential,
    handleCancelEditCredential,
    handleUpdateCredential,
    handleDeleteCredential,
  };
}
